import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss'],
  standalone: false,
})
export class MainFooterComponent {

  /* External privacy policy URL used in footer navigation */
  privacyUrl = environment.privacyURL;

}
